import { alpha, Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';

const triggerBg = (theme: Theme) =>
  theme.palette.mode === 'light'
    ? alpha(theme.palette.text.primary, 0.08)
    : alpha(theme.palette.common.white, 0.12);

export const HEADER_TRIGGER_HEIGHT = 28;

const triggerSurface = (open: boolean) => ({
  cursor: 'pointer',
  height: HEADER_TRIGGER_HEIGHT,
  minHeight: HEADER_TRIGGER_HEIGHT,
  transition: (theme: Theme) =>
    theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
    }),
  ...(open && { bgcolor: triggerBg }),
  '&:hover': {
    bgcolor: triggerBg,
  },
});

export const headerTriggerSx = (open: boolean): SystemStyleObject<Theme> => ({
  ...triggerSurface(open),
  borderRadius: 4,
  px: 0.9,
});

export const headerIconTriggerSx = (open: boolean): SystemStyleObject<Theme> => ({
  ...triggerSurface(open),
  width: HEADER_TRIGGER_HEIGHT,
  minWidth: HEADER_TRIGGER_HEIGHT,
  borderRadius: '50%',
  p: 0,
});
